import { useEffect } from 'react';
import { useCookies } from 'react-cookie';

import { useLoginResponseStore } from 'store/loginResponseStore';
import { AUTH_TOKEN_COOKIE, getAuthTokenCookieDomain } from 'shared/constants/cookies';
import { ONE_DAY_IN_SECONDS } from 'shared/constants/time';

export const useUpdateAuthTokenCookie = () => {
  const { loginResponse } = useLoginResponseStore();
  const authToken = loginResponse?.data.accessCode;
  const expiresIn = loginResponse?.data.expiresIn;

  const [, setCookie, removeCookie] = useCookies([AUTH_TOKEN_COOKIE]);

  useEffect(() => {
    if (authToken) {
      const expires = new Date();
      expires.setSeconds(expires.getSeconds() + (expiresIn ?? ONE_DAY_IN_SECONDS));

      setCookie(AUTH_TOKEN_COOKIE, authToken, {
        domain: getAuthTokenCookieDomain(),
        path: '/',
        expires,
        secure: true,
      });
    } else {
      removeCookie(AUTH_TOKEN_COOKIE, {
        domain: getAuthTokenCookieDomain(),
        path: '/',
        secure: true,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authToken]);
};
